import type { ClientPropertyLandDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { LAND_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/LandForm/landFormDefaults";
import type { LandFormInput } from "web_myplann/Portfolio/Forms/LandForm/landFormSchema";

export const mapPropertyToLandForm = (
	property: ClientPropertyLandDetailResponseDTO,
): LandFormInput => ({
	name: property.name ?? DEFAULTS.name,
	location: property.location ?? DEFAULTS.location,
	locationMunicipality:
		property.locationMunicipality ?? DEFAULTS.locationMunicipality,
	locationZipCode: property.locationZipCode ?? DEFAULTS.locationZipCode,
	parcelNumber: property.parcelNumber ?? DEFAULTS.parcelNumber,
	landSize: property.landSize ?? DEFAULTS.landSize,
	landValue: property.landValue ?? DEFAULTS.landValue,
	purchaseDate: parseIsoDate(property.purchaseDate),
	description: property.description ?? DEFAULTS.description,
	forInvestments: property.forInvestments ?? DEFAULTS.forInvestments,
});
